export const openInNewTab = (url: string) => {
  if (typeof window === 'undefined' || typeof window.open !== 'function') {
    return null;
  }

  const newWindow = window.open(url, '_blank', 'noopener');

  if (newWindow) {
    newWindow.opener = null;
  }

  return newWindow;
};
